import { Component } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { Router } from '@angular/router';
import { CommonService } from '../../../../../shared/services/common.service';

@Component({
  selector: 'app-submitgrievance',
  templateUrl: './submitgrievance.component.html',
  styleUrl: './submitgrievance.component.css'
})
export class SubmitgrievanceComponent {
  grievanceForm: FormGroup;
  GrievanceList: any[] = [];
  grievanceId: any;
  grievanceDocumentFile: File | null = null;
  grievanceDocumentfileErrors: { typeError: boolean; sizeError: boolean } = { typeError: false, sizeError: false };
  maxSizeInMB = 10;

  msMeUserName = sessionStorage.getItem('userId');
  constructor(
    private fb: FormBuilder,
    private apiService: ApiService, private toastrService: ToastrService, private router: Router , private commonService: CommonService,) {
    this.grievanceForm = this.fb.group({
      typeOfGrievance: new FormControl('', [Validators.required]),
      subject: new FormControl('', [Validators.minLength(3), Validators.maxLength(500), Validators.pattern(this.commonService.grievanceDescription)]),
      description: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(500),        
        Validators.pattern(this.commonService.grievanceDescription)
      ]),
      documents: this.fb.array([])
    });
  }

  async ngOnInit(): Promise<void> {
    await this.loadGrievanceList();
  }


  async loadGrievanceList(): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETGRIEVANCELIST).subscribe(
      (result) => {
        if (result.status) {
          this.GrievanceList = result.data;
        }
      }
    );
  } 
   

  onGrievanceFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.grievanceDocumentFile = input.files[0];

      // Reset file errors
      this.grievanceDocumentfileErrors = { typeError: false, sizeError: false };

      // Check file type (only images like jpg, png)
      const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf', 'application/zip'];
      if (!validTypes.includes(this.grievanceDocumentFile.type)) {
        this.grievanceDocumentfileErrors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024;
      if (this.grievanceDocumentFile.size > maxSizeInBytes) {
        this.grievanceDocumentfileErrors.sizeError = true;
      }
    } 
  }

  onPressBack() {
    this.router.navigate(['/grievanceDashboard']);
  }

  Reset() {
    window.location.reload();
    this.grievanceForm.clearValidators();
    this.grievanceForm.reset();
  }

  onSubmit(form: any) {

    if (form.valid) {
      var formdatavalue = {
        grievanceId: this.grievanceForm.get('typeOfGrievance')?.value,
        subject: this.grievanceForm.get('subject')?.value,
        description: this.grievanceForm.get('description')?.value,
        documents: this.grievanceDocumentFile
      };
      const formData = new FormData();
      formData.append('grievanceId', this.grievanceForm.get('typeOfGrievance')?.value);
      formData.append('subject', this.grievanceForm.get('subject')?.value);
      formData.append('description', this.grievanceForm.get('description')?.value);
      const msMeUserName = this.msMeUserName || '';
      formData.append('msMeUserId', msMeUserName);   

      if (this.grievanceDocumentFile) {
        formData.append('grievanceFile', this.grievanceDocumentFile, this.grievanceDocumentFile.name);
      }

      this.apiService.postRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.MSMESUBMITGRIEVANCE, formData).subscribe(
        (result) => {
          if (result.status) {
            this.toastrService.success(result.message);
            this.router.navigate(['/grievanceDashboard']);
          }
        }
      );
      
    } else {
      this.grievanceForm.markAllAsTouched();
      this.toastrService.error("Form is invalid");
      return;
    }
  } 


}
